// extracted by mini-css-extract-plugin
export default {"root":"NavMenu_root__Vatqn","withGradient":"NavMenu_withGradient__+p1N9","list":"NavMenu_list__2sfon dn db-m l-0 r-0 t-16 b-16 t-m-20 b-m-20"};